import { strCode } from "../../../consts";

import Step1 from "./Step1";
import Step2 from "./Step2";

const MfaSetupTutorial = [
  { title: strCode.MFA_SETUP_TUTORIAL_STEP1_TITLE, component: <Step1 /> },
  {
    title: strCode.MFA_SETUP_TUTORIAL_STEP2_TITLE,
    component: <Step2 />
  }
];

export default MfaSetupTutorial;
